import React from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import DayPicker from 'react-day-picker';
import NumericInput from 'react-numeric-input';

const DateTimeCard = React.memo(function DateTimeCard({
  state,
  errors,
  onVehicleTypeChange,
  onTripCountChange,
  onPickupDateTimeChange,
  onPickupDateTimeReturnChange,
  onRecurringEndDateChange,
  onChange,
  onDayClick,
  onPaxCountReturnChange,
  onFlightHourReturnChange,
  onFlightMinuteReturnChange,
}) {
  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-violet" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-violet"><i className="fas fa-calendar-alt" /></span>
        <span className="rx-card-title">Date &amp; Time</span>
      </div>
      <div className="rx-card-body">
        <div className="rx-cols-2">
          <div className="rx-fg">
            <label>Vehicle Type <span className="req">*</span></label>
            <SelectBox
              dataSource={state.dropdownVehicleType.length > 0 ? state.dropdownVehicleType : []}
              placeholder="Select vehicle type"
              name="vehicleTypeId"
              defaultValue={0}
              value={state.vehicleTypeId}
              displayExpr="apiVehicleTypeDescription"
              valueExpr="rowIndex"
              onSelectionChanged={onVehicleTypeChange}
              showClearButton={true}
              searchEnabled={true}
            />
            {errors.vehicleTypeId.length > 0 && <span className="rx-err">{errors.vehicleTypeId}</span>}
          </div>
          <div className="rx-fg">
            <label>No. of Trips</label>
            <NumericInput className="form-control form-control-sm" disabled={state.tripTypeId === '2' || state.tripTypeId === '3' || state.rideId > 0} name="noOfTrip" title="Number of Trips" value={state.noOfTrip} min={1} max={20} onChange={(value) => onTripCountChange(value)} />
            {errors.noOfTrip.length > 0 && <span className="rx-err">{errors.noOfTrip}</span>}
          </div>
        </div>

        <div className="rx-fg">
          <label>Pick-up Date &amp; Time <span className="req">*</span></label>
          <DateBox
            type="datetime"
            name="puDateTime"
            placeholder="MM/dd/yyyy HH:mm"
            displayFormat="MM/dd/yyyy HH:mm"
            showAnalogClock={true}
            useMaskBehavior={true}
            defaultValue={state.puDateTime}
            value={state.puDateTime}
            onValueChanged={onPickupDateTimeChange}
            width="100%"
            disabled={false}
            acceptCustomValue={false}
          />
          {errors.puDateTime.length > 0 && <span className="rx-err">{errors.puDateTime}</span>}
        </div>

        {/* Return Details */}
        {state.tripTypeId === '2' && (
          <div className="rx-sub-card">
            <div className="rx-sub-card-hd">Return Details</div>
            <div className="rx-sub-card-body">
              <div className="rx-cols-3">
                <div className="rx-fg">
                  <label>Pilot <span className="req">*</span></label>
                  <NumericInput className="form-control form-control-sm" name="pilotCountReturn" title="Pilot Count" value={state.pilotCountReturn} min={0} max={100} onChange={(value) => onPaxCountReturnChange('p', value)} />
                  {errors.pilotCountReturn.length > 0 && <span className="rx-err">{errors.pilotCountReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>Crew <span className="req">*</span></label>
                  <NumericInput className="form-control form-control-sm" name="crewCountReturn" title="Crew Count" value={state.crewCountReturn} min={0} max={100} onChange={(value) => onPaxCountReturnChange('c', value)} />
                </div>
                <div className="rx-fg">
                  <label>F/A <span className="req">*</span></label>
                  <NumericInput className="form-control form-control-sm" name="flightAttandCountReturn" title="Flight Attendant Count" value={state.flightAttandCountReturn} min={0} max={100} onChange={(value) => onPaxCountReturnChange('f', value)} />
                </div>
              </div>
              <div className="rx-fg">
                <label>Pick-up Date &amp; Time <span className="req">*</span></label>
                <DateBox
                  type="datetime"
                  name="puDateTimeReturn"
                  placeholder="MM/dd/yyyy HH:mm"
                  displayFormat="MM/dd/yyyy HH:mm"
                  showAnalogClock={true}
                  useMaskBehavior={true}
                  defaultValue={state.puDateTimeReturn}
                  value={state.puDateTimeReturn}
                  onValueChanged={onPickupDateTimeReturnChange}
                  width="100%"
                  disabled={false}
                  acceptCustomValue={false}
                  min={state.puDateTime}
                />
                {errors.puDateTimeReturn.length > 0 && <span className="rx-err">{errors.puDateTimeReturn}</span>}
              </div>
              <div className="rx-cols-2">
                <div className="rx-fg">
                  <label>Flight Time [ hh ] <span className="req">*</span></label>
                  <SelectBox
                    dataSource={state.dropdownHours.length > 0 ? state.dropdownHours : []}
                    placeholder="Select Hour"
                    name="id"
                    defaultValue={0}
                    value={state.flightHourReturn}
                    displayExpr="name"
                    valueExpr="id"
                    onSelectionChanged={onFlightHourReturnChange}
                    showClearButton={true}
                    searchEnabled={true}
                  />
                  {errors.flightTimeReturn.length > 0 && <span className="rx-err">{errors.flightTimeReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>[ min ]</label>
                  <SelectBox
                    dataSource={state.dropdownMinutes.length > 0 ? state.dropdownMinutes : []}
                    placeholder="Select Minute"
                    name="id"
                    defaultValue={0}
                    value={state.flightMinuteReturn}
                    displayExpr="name"
                    valueExpr="id"
                    onSelectionChanged={onFlightMinuteReturnChange}
                    showClearButton={true}
                    searchEnabled={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Recurring Details */}
        {state.tripTypeId === '3' && (
          <div className="rx-sub-card">
            <div className="rx-sub-card-hd">Recurring Details</div>
            <div className="rx-sub-card-body">
              <div className="rx-cols-2">
                <div className="rx-fg">
                  <label>Repeat Type <span className="req">*</span></label>
                  <select className="rx-ff" name="recurringTypeId" value={state.recurringTypeId} onChange={onChange}>
                    <option value="1">Daily</option>
                    <option value="2">Weekly</option>
                    <option value="3">Monthly</option>
                  </select>
                </div>
                <div className="rx-fg">
                  <label>End Date <span className="req">*</span></label>
                  <DateBox
                    type="date"
                    name="recurringEndDate"
                    placeholder="mm/dd/yyyy"
                    useMaskBehavior={true}
                    defaultValue={state.recurringEndDate}
                    value={state.recurringEndDate}
                    onValueChanged={onRecurringEndDateChange}
                    width="100%"
                    disabled={false}
                    acceptCustomValue={false}
                    min={state.puDateTime}
                  />
                  {errors.recurringEndDate.length > 0 && <span className="rx-err">{errors.recurringEndDate}</span>}
                </div>
              </div>
              {state.recurringTypeId == 1 && (
                <DayPicker selectedDays={state.selectedDays} onDayClick={onDayClick} />
              )}
              {state.recurringTypeId == 2 && (
                <div className="rx-day-checks">
                  {[['isWeekSun', 'SUN'], ['isWeekMon', 'MON'], ['isWeekTue', 'TUE'], ['isWeekWed', 'WED'], ['isWeekThu', 'THU'], ['isWeekFri', 'FRI'], ['isWeekSat', 'SAT']].map(([name, lbl]) => (
                    <label className="rx-day-chk" key={name}>
                      <input type="checkbox" checked={state[name]} onChange={onChange} name={name} />
                      {lbl}
                    </label>
                  ))}
                </div>
              )}
              {state.recurringTypeId == 3 && (
                <div className="rx-day-checks">
                  {[['isMonthSun', 'SUN'], ['isMonthMon', 'MON'], ['isMonthTue', 'TUE'], ['isMonthWed', 'WED'], ['isMonthThu', 'THU'], ['isMonthFri', 'FRI'], ['isMonthSat', 'SAT']].map(([name, lbl]) => (
                    <label className="rx-day-chk" key={name}>
                      <input type="checkbox" checked={state[name]} onChange={onChange} name={name} />
                      {lbl}
                    </label>
                  ))}
                </div>
              )}
              {errors.recurring.length > 0 && <span className="rx-err">{errors.recurring}</span>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default DateTimeCard;
